"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendConnectivityRequest = exports.CONNECTIVITY_CHECKER_SERVICE_ID = exports.connectAsync = void 0;
const utils_1 = require("@streamr/utils");
const uuid_1 = require("uuid");
const Err = __importStar(require("../helpers/errors"));
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
const NodeWebsocketClientConnection_1 = require("./websocket/NodeWebsocketClientConnection");
const WebsocketClientConnector_1 = require("./websocket/WebsocketClientConnector");
const version_1 = require("../helpers/version");
const logger = new utils_1.Logger(module);
// TODO use options option or named constant?
const connectAsync = async ({ url, allowSelfSignedCertificate, timeoutMs = 1000 }) => {
    const socket = new NodeWebsocketClientConnection_1.WebsocketClientConnection();
    let result;
    try {
        result = await (0, utils_1.runAndRaceEvents3)([
            () => { socket.connect(url, allowSelfSignedCertificate); }
        ], socket, ['connected', 'error'], timeoutMs);
    }
    catch {
        throw new Err.ConnectionFailed('WebSocket connection timed out');
    }
    if (result.winnerName === 'error') {
        throw new Err.ConnectionFailed('Could not open WebSocket connection');
    }
    return socket;
};
exports.connectAsync = connectAsync;
exports.CONNECTIVITY_CHECKER_SERVICE_ID = 'system/connectivity-checker';
const CONNECTIVITY_CHECKER_TIMEOUT = 5000;
const sendConnectivityRequest = async (request, entryPoint) => {
    let outgoingConnection;
    const wsServerInfo = {
        host: entryPoint.websocket.host,
        port: entryPoint.websocket.port,
        tls: entryPoint.websocket.tls,
    };
    const url = (0, WebsocketClientConnector_1.connectivityMethodToWebsocketUrl)(wsServerInfo, 'connectivityRequest');
    logger.debug(`Attempting connectivity check with entrypoint ${url}`);
    try {
        outgoingConnection = await (0, exports.connectAsync)({
            url,
            allowSelfSignedCertificate: request.allowSelfSignedCertificate
        });
    }
    catch (e) {
        throw new Err.ConnectionFailed(`Failed to connect to entrypoint for connectivity check: ${url}`, e);
    }
    // send connectivity request
    const msg = {
        serviceId: exports.CONNECTIVITY_CHECKER_SERVICE_ID,
        messageId: (0, uuid_1.v4)(),
        body: {
            oneofKind: 'connectivityRequest',
            connectivityRequest: request
        }
    };
    const responseAwaiter = () => {
        return new Promise((resolve, reject) => {
            const timeoutId = setTimeout(() => {
                // TODO should we have some handling for this floating promise?
                outgoingConnection.close(false);
                reject(new Err.ConnectivityResponseTimeout('timeout'));
            }, CONNECTIVITY_CHECKER_TIMEOUT);
            const listener = (bytes) => {
                // TODO should we have some handling for this floating promise?
                outgoingConnection.close(false);
                try {
                    const message = DhtRpc_1.Message.fromBinary(bytes);
                    if (message.body.oneofKind === 'connectivityResponse') {
                        logger.debug('ConnectivityResponse received: ' + JSON.stringify(DhtRpc_1.Message.toJson(message)));
                        const connectivityResponseMessage = message.body.connectivityResponse;
                        const remoteProtocolVersion = connectivityResponseMessage.protocolVersion;
                        outgoingConnection.off('data', listener);
                        clearTimeout(timeoutId);
                        if ((0, version_1.isMaybeSupportedProtocolVersion)(remoteProtocolVersion)) {
                            resolve(connectivityResponseMessage);
                        }
                        else {
                            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                            reject(`Unsupported version: ${remoteProtocolVersion}`);
                        }
                    }
                }
                catch (err) {
                    logger.trace('Could not parse message', { err });
                }
            };
            outgoingConnection.on('data', listener);
        });
    };
    try {
        const retPromise = responseAwaiter();
        outgoingConnection.send(DhtRpc_1.Message.toBinary(msg));
        logger.trace('ConnectivityRequest sent: ' + JSON.stringify(DhtRpc_1.Message.toJson(msg)));
        return await retPromise;
    }
    catch (e) {
        logger.error('error getting connectivityresponse');
        throw e;
    }
};
exports.sendConnectivityRequest = sendConnectivityRequest;
//# sourceMappingURL=connectivityChecker.js.map